/**
 * La tabla de recorridos destino (`InputRadioTagTable`, la de siempre) tal y
 * como la usan «Transferir tramo» y «Mover tramos» (plan 2026-10-15 § 3).
 */

// Columnas que no dicen nada de un recorrido destino: quedan ROID, nombre,
// fecha de registro (primer tramo) y fecha final (último tramo).
export const TARGET_HIDDEN_COLUMN_IDS = [
  'state',
  'capitol',
  'subCapitol',
  'predefinedOrder',
  'concession',
  'team',
  'track',
  'direction',
  'user',
  'creationDate',
  'road',
  'pkInit',
  'pkEnd',
  'description',
];

// Filtros (revisión del 22-oct), con la regla de las ventanas de «Vincular»:
// solo los que pueden quitar alguna fila. Quedan ROID (expediente e índice),
// nombre y fechas. Fuera: equipo y estado (los fuerza el servidor: mismo
// equipo y pendientes de validar), y concesión, carretera, PK, descripción y
// creador, que en los recorridos de un mismo equipo valen casi siempre lo
// mismo y no ayudan a elegir.
export const TARGET_HIDDEN_FILTER_IDS = [
  'pkInit',
  'pkEnd',
  'description',
  'concession',
  'road',
  'team',
  'capitol',
  'subCapitol',
  'predefinedOrder',
  'classification',
  'track',
  'state',
  'creator',
];
